<template>
  <div class="login-box">
    <img src="../../assets/img/logo2.png" alt="" class="logo">
    <div class="login-from">
      <h3 class="login-type flex-around">
        <a href="javascript:void 0" >修改密码</a>
      </h3>

      <div>
        <div class="login-from-item flex-center">
          <div class="login-from-input">
            <i class="iconfont iconzhanghao"></i>
            <van-field class="login-input-box" v-model="tel" placeholder="请输入手机号" type="tel" maxlength="11" clearable />
          </div>
        </div>
        <div class="login-from-item flex-center">
          <div class="login-from-input hals-btn">
            <i class="iconfont iconmima"></i>
            <van-field class="login-input-box" placeholder="请输入验证码" maxlength="6" v-model="code" clearable />
            <van-button type="info" class="get-code2"  @click="getSms">{{codeText}}</van-button>
          </div>
        </div>
        <a href="javascript:void 0" class="submit-btn">立即修改</a>

        <p><a href="/phoneLogin/login">返回登录</a></p>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: "Login",
    data() {
      return {
        tel: '',
        code:'',
        codeText: '发送验证码', // 验证码文字
        id: null, // 计时器id
        timeId: null, // 一次性计时器id
      }
    },
    created() {
    },
    methods:{
      /*
      * 获取验证码
      * */
      getSms(){
        if (this.$tools.checkTel(this.tel)) {
          this.$toast('请输入正确的手机号')
          return
        }
        if (this.codeText === '发送验证码' || this.codeText === '重新发送') {
          let num = 60
          this.id = setInterval(() => {
            if (num === 0) {
              clearInterval(this.id)
              this.codeText = '重新发送'
              return
            }
            num--
            this.codeText = "重新发送(" + num + "s)"
          }, 1000)
          // this.$api.apiLogin.sendPhoneCode({
          //   userName: this.tel,
          //   type: 1,
          //   userType: 1
          // }).then().catch(e => {
          //   this.$toast(e.info)
          //   this.codeText = '重新发送'
          //   clearInterval(this.id)
          // })
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .login-box {
    width: 100%;

    .logo {
      display: block;
      width: 70%;
      padding: 60px 0 30px;
      margin: 0 auto;
    }

    .login-from {
      margin: 0 20px;
      padding: 30px;
      background-color: #ffffff;
      box-shadow: 0px 3px 40px 0px
      rgba(27, 169, 225, 0.58);
      border-radius: 14px;

      .login-type {
        width: 250px;
        margin: 0 auto 10px;
        font-weight: normal;

        a {
          display: block;
          width: 80px;
          height: 40px;
          text-align: center;
          line-height: 36px;
          font-size: 18px;
          color: #333;

          &.active {
            color: #2b8ee3;
            position: relative;
            &:before{
              position: absolute;
              left: 50%;
              bottom: 0;
              content: '';
              transform: translate(-50%,0);
              width: 30px;
              height: 3px;
              background-color: #0c7ebe;
              border-radius: 3px;
            }
          }
        }
      }

      .login-from-item {
        margin-bottom: 20px;

        span {
          display: block;
          width: 100px;
          padding-right: 20px;
          text-align: right;
          font-size: 16px;
          line-height: 40px;
          color: #666666;
        }
        .login-from-input{
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          border-bottom: 1px solid #ccc;
          i{
            font-size: 20px;
            color: #666;
          }
          .login-input-box{
            flex: 1;
          }
          .get-code{
            display: block;
            width: 81px;
            height: 27px;
            text-align: center;
            line-height: 27px;
            color: #1ba5d9;
            font-size: 14px;
          }
          .get-code2{
            width: 81px;
            height: 27px;
            padding: 0;
            border:0;

            background-image: linear-gradient(90deg,
              #0d80c1 0%,
              #1ba5d9 100%);
            border-radius: 13px;
            span{
              width: 81px;
              height: 27px;
              padding: 0;
              text-align: center;
              line-height: 27px;
              font-size: 14px;
              color: #fff;
            }
          }
        }
      }
      a.submit-btn{
        display: block;
        width: 100%;
        height: 48px;
        margin: 30px auto;
        text-align: center;
        line-height: 48px;
        color: #fff;
        font-size: 18px;
        background-image: linear-gradient(90deg,
          #0d80c1 0%,
          #1aa8e3 100%);
        border-radius: 8px;
      }

      p{
        text-align: center;
        font-size: 16px;
        color: #666;
        a{
          color: #0c7cbc;
        }
      }
    }
    .wx-login-box{
      p{
        margin-top: 20px;
        height: 21px;
        line-height: 21px;
        text-align: center;
        font-size: 16px;
        color: #fff;
        position: relative;
        &:before{
          position: absolute;
          top: 10px;
          left: 20%;
          content: '';
          width: 20%;
          height: 1px;
          background: #fff;
        }
        &:after{
          position: absolute;
          top: 10px;
          right: 20%;
          content: '';
          width: 20%;
          height: 1px;
          background: #fff;
        }
      }
    }

  }
</style>